import { SequenceNodeType } from "@/@types/flows/sequences";
import { CreateNodeDto } from "@/@types/flows/sequences/dto";
import {
  automaticCallBody,
  timeIntervalBody,
  emailBody,
  whatsappBody,
  smsBody,
} from "@/app/flows/sequences/utils/NodeFactory/defaults";
import { SequenceType } from "../enums";

export abstract class SequenceNodeFactory {
  static create<T extends SequenceNodeType>(type: T, sequenceType?: SequenceType): CreateNodeDto {
    if (type === SequenceNodeType.TimeInterval) return timeIntervalBody(sequenceType || SequenceType.AutomaticProgressive);
    if (type === SequenceNodeType.AutomaticCall) return automaticCallBody();
    if (type === SequenceNodeType.Email) return emailBody();
    if (type === SequenceNodeType.Whatsapp) return whatsappBody();
    if (type === SequenceNodeType.Sms) return smsBody();

    throw new Error(`Type ${type} does not exists`);
  }
}
